import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-progress-form',
  templateUrl: './project-progress-form.component.html',
  styleUrls: ['./project-progress-form.component.css']
})
export class ProjectProgressFormComponent implements OnInit {

  title = "Project Photos";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/project-progress/project-progress-form/project-progress-form.component.ts